/**
 * GridElement.js
 * Manages grid elements that are made of a bubble and a position
 */

import { Bubble } from "./Bubble";

export class GridElement {
    /**
     * @public
     * @param {Number} column
     * @param {Number} row
     */
    constructor(column, row) {
        /** @public @type {Bubble} */
        this.bubble = null;

        /** @public @type {Number} */
        this.column = column;
        /** @public @type {Number} */
        this.row = row;

        /** @screenPos @type {Object} */
        this.screenPos = { x: 0, y: 0 };

        /** @public @type {Boolean} - Used by various algorithms */
        this.processed = false;
    }

    /**
     * @public
     * @returns {Number}
     */
    get x() {
        return this.screenPos.x;
    }

    /**
     * @public
     * @returns {Number}
     */
    get y() {
        return this.screenPos.y;
    }
}
